module.exports = __webpack_public_path__ + "img/commonly.95430887.png";